import React, { useState, useEffect, useRef } from 'react';
import { Player } from '@lordicon/react';
import styles from './Timeline.module.css';
import Button from '../button/Button';
import feed from "../../icons/wired-outline-2610-lead-generation-hover-pinch (1).json"
import clients from "../../icons/wired-outline-274-male-and-two-female-hover-nodding.json"
import proud from "../../icons/wired-outline-1028-web-advertising-hover-pinch (1).json"
import digital from "../../icons/wired-outline-1018-signature-sig-hover-pinch (1).json"

export default function ScrollTimeline() {
  const [progress, setProgress] = useState(0);
  const timelineRef = useRef(null);
  const playerRefs = useRef([]);

  const items = [
    {
      icon: feed,
      title: "הפיד מחמם את הלידים עוד לפני שיחה",
      description:
        "לקוחות פוטנציאליים נחשפים לתוכן שלכם ומגיעים אליכם כבר מחוברים ומעוניינים. הפיד שלכם עושה את העבודה השיווקית במקומכם - מעביר מסר, בונה אמון ומחמם את הליד עוד לפני השיחה הראשונה.",
    },
    {
      icon: clients,
      title: "לקוחות מגיעים סקרנים, לא סקפטיים",
      description:
        "במקום להתחיל כל שיחה מאפס ולשכנע, הלקוחות שלכם כבר מכירים אתכם דרך התוכן. הם מגיעים פתוחים, מעוניינים ומוכנים לעבוד איתכם - כי הם כבר חיברו אליכם רגשית דרך המסך.",
    },
    {
      icon: proud,
      title: "הקמפיינים הממומנים סוף סוף משתלמים",
      description:
        "כשיש לכם פיד חזק שמחמם לידים, הקמפיינים הממומנים הופכים להיות הרבה יותר יעילים. הכסף שאתם משקיעים בפרסום מניב תוצאות טובות יותר כי הלקוחות מגיעים חמים ומעוניינים, לא קרים ומפוקפקים.",
    },
    {
      icon: digital,
      title: "הנוכחות הדיגיטלית נראית כמו העסק באמת - מקצועית, חדה, אמיתית",
      description:
        "העיצוב והמיתוג שלכם משדרים מקצועיות ואמינות. לקוחות פוטנציאליים רואים שהגעתם למקום הנכון - עסק רציני שמבין את התחום ויודע מה הוא עושה. זה מה שגורם להם לבחור בכם על פני המתחרים.",
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (!timelineRef.current) return;

      const element = timelineRef.current;
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const elementTop = rect.top;
      const elementHeight = rect.height;

      const startPoint = windowHeight * 0.7;
      const endPoint = windowHeight * 0.3;

      if (elementTop > startPoint) {
        setProgress(0);
      } else if (elementTop + elementHeight < endPoint) {
        setProgress(100);
      } else {
        const scrolled = startPoint - elementTop;
        const total = elementHeight + (startPoint - endPoint);
        const percentage = (scrolled / total) * 100;
        setProgress(Math.min(Math.max(percentage, 0), 100));
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleComplete = (index) => {
    setTimeout(() => {
      playerRefs.current[index]?.playFromBeginning();
    }, 2500);
  };

  useEffect(() => {
    playerRefs.current.forEach((ref) => {
      ref?.playFromBeginning();
    });
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div ref={timelineRef} className={styles.timeline}>
          <div className={styles.lineBackground} />
          <div className={styles.lineProgress} style={{ height: `${progress}%` }} />

          <div className={styles.itemsContainer}>
            {items.map((item, index) => {
              const itemProgress = Math.min(Math.max((progress - index * 20) * 5, 0), 100);
              const isActive = itemProgress > 0;

              return (
                <div key={index} className={styles.item}>
                  <div className={`${styles.circle} ${isActive ? styles.circleActive : ''}`}>
                    <div className={styles.iconWrapper}>
                      <Player
                        icon={item.icon}
                        ref={(el) => (playerRefs.current[index] = el)}
                        size="100%"
                        colorize="black"
                        onComplete={() => handleComplete(index)}
                      />
                    </div>
                    {isActive && itemProgress > 50 && <div className={styles.pulse} />}
                  </div>

                  <div
                    className={`${styles.content} ${isActive ? styles.contentActive : ''}`}
                    style={{
                      transform: `translateX(${isActive ? 0 : 40}px)`,
                      opacity: isActive ? 1 : 0.25,
                    }}
                  >
                    <h3 className={styles.title}>{item.title}</h3>
                    <p className={styles.description}>{item.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
  
    </div>
  );
}